import { type GetStaticPropsContext } from 'next'
import { CMS_SHOWROOM_PAGE_BY_SLUG_QUERY } from 'constants/queries'
import { prepareGetStaticProps } from '../prepareGetStaticProps'

export function prepareGetStaticPropsForShowroomPage(
  context: GetStaticPropsContext,
  { slug, route }: { slug: string; route?: string }
) {
  return prepareGetStaticProps(context, {
    slug,
    query: CMS_SHOWROOM_PAGE_BY_SLUG_QUERY,
    route,
  })
}
